import { ref, watch } from '@vue/composition-api'
import { successNotification } from '@/utils/toast-notifications'
// errorNotification,
export default function useAddDevice(ctx) {
  const userTypes = ['user', 'driver']
  const userType = ref('user')
  const selectedExternalId = ref(null)
  const loadingTestBtn = ref(false)
  const showErrorMessage = ref(false)
  const addDeviceHandler = async () => {
    try {
      loadingTestBtn.value = true
      if (selectedExternalId.value) {
        const result = await ctx.root.$store.dispatch('notifications/getUserFcmToken', {
          userType: userType.value, externalId: selectedExternalId.value,
        })
        await ctx.root.$store.dispatch('notifications/subscribetoFcm', result.data.data.fcmToken)
        successNotification('Success')
      } else {
        showErrorMessage.value = true
      }
    } catch (err) {
      console.log(err)
      // errorNotification('The user has been already added')
    } finally {
      loadingTestBtn.value = false
    }
  }
  watch(userType, () => {
    showErrorMessage.value = false
    selectedExternalId.value = null
  })

  return {
    userType,
    userTypes,
    selectedExternalId,
    loadingTestBtn,
    addDeviceHandler,
    showErrorMessage,
  }
}
